import NotificationModel from '@/dashboard/models/settings/NotificationModel';
import { RequestCommonParams, handleRequestError } from '@jove-frontend/uikit';
import { api } from '@jove-frontend/uikit';
import { isArray } from 'lodash';
import qs from 'qs';

// get user notification
export const apiGetUserNotificationList = async (
  payload?: {
    limit?: number;
    offset?: number;
    read?: boolean | null;
  } & RequestCommonParams
) => {
  try {
    const mergeData = { limit: 100, offset: 0, ...payload };
    const res = await api.get(`/notifications?${qs.stringify(mergeData)}`);
    if (!isArray(res.data?.data)) res.data.data = [];

    res.data.data = res.data.data.map((item) => {
      const model = new NotificationModel();
      model.transformServeDataToInstance(item);
      return model;
    });

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// have read notification
export const apiReadNotification = async (payload: { notification_id: string } & RequestCommonParams) => {
  try {
    const res = await api.patch(`/notifications/${payload.notification_id}`);

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// read all notification
export const apiReadAllNotification = async (payload: RequestCommonParams) => {
  try {
    const res = await api.patch(`/notifications/all_read`);

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// get delete account reason
export const apiGetDeleteAccountReasonList = async (payload: RequestCommonParams) => {
  try {
    const res = await api.get(`/users/client-portal/delete-account-reason`);

    res.data = (res.data || []).map((item) => {
      return {
        value: item,
        label: item,
      };
    });

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// delete account
export const apiDeleteAccount = async (payload: { reason: string } & RequestCommonParams) => {
  try {
    const res = await api.patch(`/users/client-portal/delete-account`, payload);

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};
